<div
  class="{{ isMobile ? 'gallery-background-sp' : 'gallery-background' }}"
  (click)="onNoClick()"
>
  <div class="{{ isMobile ? 'gallery-img-sp' : 'gallery-img' }}">
    <img
      src="{{ images[current].url }}"
      alt="{{ images[current].description }}"
      *ngIf="current < images.length"
    />
    <iframe
      #media
      class="tile-img img-orientation link-cursor youtube-player"
      [src]="iframeUrl"
      [title]="media[current - images.length].name"
      *ngIf="current >= images.length && media.length > 0"
    ></iframe>
  </div>
  <div
    class="{{ isMobile ? 'gallery-c-sp' : 'gallery-c' }}"
    (click)="onNoClick()"
    *ngIf="current < images.length"
  >
    <h3 innerHtml="{{ images[current].description }}"></h3>
    <h5 *ngIf="images[current].source">{{ images[current].source }}</h5>
    <p *ngIf="images[current].comment">{{ images[current].comment }}</p>
  </div>
</div>
<button
  class="{{ isMobile ? 'nav-left-sp' : 'nav-left' }}"
  mat-fab
  color="primary"
  (click)="navBackward()"
>
  <mat-icon>chevron_left</mat-icon>
</button>
<button mat-button class="gallery-pos" color="warn" [disabled]="true">
  {{ current + 1 }}/{{ imageMediaLength() }}
</button>
<button
  class="{{ isMobile ? 'nav-right-sp' : 'nav-right' }}"
  mat-fab
  color="primary"
  (click)="navForward()"
>
  <mat-icon>chevron_right</mat-icon>
</button>
